import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface DialogPortalProps {
  children: ReactNode;
}

const DialogPortal = ({ children }: DialogPortalProps) => {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let element = document.getElementById('dialog-portal-root');
    if (!element) {
      element = document.createElement('div');
      element.id = 'dialog-portal-root';
      document.body.appendChild(element);
    }
    setPortalElement(element);

    return () => {
      if (element && element.childNodes.length === 0) {
        document.body.removeChild(element);
      }
    };
  }, []);

  if (!portalElement) return null;

  return createPortal(children, portalElement);
};

export default DialogPortal;
